import type { DpModule } from '@/core/modules/DpModule';
import type { IDpProvider } from '@/core/di/DpProvider';
import { RootModule } from '@/common/root';
import { HttpClientModule } from '@/modules/http-client';
import { AdapterProvider } from './providers';

export class SettingsCallRecordingModule implements DpModule {
  static readonly namespace = Symbol('SettingsCallRecordingModule');

  static readonly requires = [RootModule, HttpClientModule];

  providers(): IDpProvider[] {
    return [AdapterProvider];
  }
}
